import { PageLayout } from '~/components/PageLayout/PageLayout';
import { withPrivateRoute } from '~/hocs/withPrivateRoute';
import { Schema } from './components/club-form.schema';
import { useCreateClubMutation } from '../mutations';
import { ClubForm } from './components/club-form';
import { Fragment } from 'react/jsx-runtime';
import { useNavigate } from 'react-router';

export const Page = withPrivateRoute(() => {
  const mutation = useCreateClubMutation();
  const navigate = useNavigate();

  async function onSubmit(payload: Partial<Schema>) {
    const { data } = await mutation.mutateAsync({
      is_active: payload.is_active!,
      district: payload.district!,
      website: payload.website!,
      email: payload.email!,
      name: payload.name!,
    });

    navigate(`../${data.id}`);
  }

  return (
    <Fragment>
      <PageLayout.Heading text="Skapa förening" />

      <PageLayout.Section>
        <ClubForm onSubmit={onSubmit} mode="create" />
      </PageLayout.Section>
    </Fragment>
  );
});
